import {MarkdownWidgetData} from '@dv5/domain'
import React, {CSSProperties, FC} from 'react'
import {useMarkdownWidgetUpdate} from "./useMarkdownWidgetUpdate"
import './MarkdownWidgetToolbar.less'

interface Props {
    canvasId: string
    widgetId: string
    data: MarkdownWidgetData
    toolbarStyles: CSSProperties
    onExpandToFull?: () => void
}

export const MarkdownWidgetToolbar: FC<Props> = ({
    canvasId,
    widgetId,
    data,
    toolbarStyles,
    onExpandToFull,
}) => {
    const {updateData} = useMarkdownWidgetUpdate({canvasId, widgetId})

    const handleCompactToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        const newCompact = !data.compact
        updateData(['compact'], {...data, compact: newCompact})
    }

    return (
        <div className='markdown-widget-toolbar' style={toolbarStyles}>
            <button
                className={`markdown-widget-toolbar__button ${data.compact ? 'markdown-widget-toolbar__button--active' : ''}`}
                onMouseDown={handleCompactToggle}
                aria-label='Toggle compact mode'
                type='button'
            >
                Compact
            </button>
            {onExpandToFull && (
                <>
                    <div className='markdown-widget-toolbar__divider' />
                    <button
                        className='markdown-widget-toolbar__button markdown-widget-toolbar__button--expand'
                        onClick={onExpandToFull}
                        aria-label='Expand to full editor'
                        type='button'
                    >
                        ↗
                    </button>
                </>
            )}
        </div>
    )
}
